import VimeoVideo, { VimeoPlayerOptions } from 'components/Common/Video/VimeoVideo'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import LightBox from '../Modal/LightBox'

const LightboxVideo = styled(VimeoVideo)`
  max-height: 90vh;
`

interface Props {
  videoId: string;
  playOnMount?: boolean;
  query?: VimeoPlayerOptions;
}

function VideoLightbox(props: Props) {
  const { videoId, playOnMount, query } = props
  const videoRef = useRef<any>(null)

  useEffect(() => {
    if (playOnMount) {
      videoRef.current?.play()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <LightBox>
    <LightboxVideo
      vimeoVideoId={videoId}
      ref={videoRef}
      query={query}
    />
  </LightBox>
}

export default VideoLightbox
